import { Slot } from "@radix-ui/react-slot";
import { type VariantProps, cva } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

const variants = cva(
  "group relative flex max-w-[272px] items-center gap-3 rounded-[6px] [&_svg]:transition-colors transition-colors px-3 py-2 border-none shadow-none text-left text-sm font-medium outline-hidden ring-grey-200/70 focus-visible:ring-3",
  {
    variants: {
      color: {
        grey: "hover:bg-grey-100 hover:[&[data-status=active]_svg]:text-grey-700 [&[data-status=active]_svg]:text-grey-700 data-[status=active]:bg-grey-100 data-[status=active]:hover:bg-grey-100 data-[status=active]:focus-visible:ring-grey-200/70 data-[status=active]:focus-visible:shadow-[0_0_0_2px] data-[status=active]:text-grey-800 focus-visible:shadow-grey-100 hover:text-grey-700 text-grey-600 hover:[&_svg]:text-grey-600 [&_svg]:text-grey-500",
        primary:
          "hover:bg-grey-50 hover:focus-visible:ring-grey-200/70 hover:[&_svg]:text-grey-600 data-[status=active]:bg-primary-100 data-[status=active]:hover:bg-primary-50 data-[status=active]:hover:text-primary-700 data-[status=active]:text-primary-700 data-[status=active]:focus-visible:ring-primary-200/70 [&[data-status=active]_svg]:text-primary-400 hover:[&[data-status=active]_svg]:text-primary-400",
      },
    },
  },
);

export const NavItem = ({
  color = "grey",
  children,
  asChild,
  selected = false,
  className,
  ...props
}: HTMLAttributes<HTMLButtonElement> & {
  asChild?: boolean;
  selected?: boolean;
} & VariantProps<typeof variants>) => {
  const Comp = asChild === true ? Slot : "button";

  return (
    <Comp
      tabIndex={0}
      className={twMerge(variants({ color }), className)}
      data-status={selected ? "active" : undefined}
      {...props}
    >
      {children}
    </Comp>
  );
};
